






















































































import Vue from 'vue';

import updateEmail from './updateEmail.vue';
import settingsPannel from './settings.vue';

import { MDCTextField } from '@material/textfield';
import { MDCSnackbar } from '@material/snackbar';
import Axios from 'axios';

interface Data {
  oldPass: string;
  newPass: string;
  newPassElem: any;
  newConfPass: string;
  newConfPassElem: any;

  snackbarS: any;
  snackbarF: any;

  valid: boolean;
}

export default Vue.extend({
  data(): Data {
    return {
      oldPass: '',
      newPass: '',
      newPassElem: null,
      newConfPass: '',
      newConfPassElem: null,
      snackbarS: null,
      snackbarF: null,
      valid: false,
    };
  },
  mounted() {
    const textFields: any = this.$el.querySelectorAll('.mdc-text-field');
    for (const textFieldElem of textFields) {
      const textField = new MDCTextField(textFieldElem);

      if (textFieldElem.dataset.name === 'newPass') {
        this.newPassElem = textField;
      } else if (textFieldElem.dataset.name === 'newConfPass') {
        this.newConfPassElem = textField;
      }

    }
    let snackElem = this.$el.querySelector('.mdc-snackbar.success') as HTMLElement;
    this.snackbarS = new MDCSnackbar(snackElem);
    snackElem = this.$el.querySelector('.mdc-snackbar.fail') as HTMLElement;
    this.snackbarF = new MDCSnackbar(snackElem);
  },
  destroyed() {
    this.snackbarF.destroy();
  },
  updated() {
    if (this.newPass !== this.newConfPass) {
      this.newPassElem.valid = false;
      this.newConfPassElem.valid = false;
      this.valid = false;
      return;
    } else {
      this.newPassElem.valid = true;
      this.newConfPassElem.valid = true;
      this.valid = true;
    }

  },
  methods: {
    updatePass() {
      if (!this.valid) {
        return;
      }

      Axios.post('/API/user/updatePassword', { OldPass: this.oldPass, NewPass: this.newPass })
        .then(() => this.snackbarS.open())
        .catch(() => this.snackbarF.open());
    },
  },
  components: {
    settingsPannel,
    updateEmail ,
  },
});
